import http from "./Axios-Config";

export const getAmbassadorBankDetails = async () => {
	return await http.get("/profile");
};

export const transferToAmbassadorBank = async (requestBody) => {
	return await http.post(`/transfer/account`, requestBody);
};
